import { createFileRoute } from '@tanstack/react-router';
import RolesPage from '@features/admin/roles/RolesPage.tsx';
import { useCreateAdminRoleStore } from '@features/admin/roles/useAdminRoleStore.ts';

export const Route = createFileRoute('/admin/roles')({
  component: RouteComponent,
  beforeLoad: () => {
    useCreateAdminRoleStore.getState().loadRoles();
  },
});

function RouteComponent() {
  return <RolesPage />;
}
